import React, { Component, ReactDOM, Ref, createRef, browserHistory } from 'react';
import { Login } from './Login';
import { CheckOut } from './CheckOut';
import { Route } from 'react-router';
import { SaveCart } from './SaveCart';
import { SavedCarts } from './SavedCarts';
import { ChangePassword } from './ChangePassword';
import { InvoiceOrderSearch } from './InvoiceOrderSearch';
import { Manage } from './Manage';
import { OrderForm } from './Orderform';
import { CreateOrderForm } from './CreateOrderForm';
import { OrderFormList } from './OrderFormList'
import { OrderSearch } from './OrderSearch'
import { Budget } from './Budget'
import { GetDefaultImageFolder } from '../registerServiceWorker';
import { AdminUser } from './AdminUser'
import { Users } from './Users';
import { OrderApproval } from './OrderApproval'
import { ClearCartPrompt } from './ClearCartPrompt';
import { withRouter, Redirect } from 'react-router-dom';
import { SessionTimedOut } from './SessionTimedOut';
import { AdminManage } from './AdminManage';
import { Product } from './Products';

export class CreateOrderFormContent extends Component {
    displayName = CreateOrderFormContent.name

    _isMountedp = false;

    constructor(props) {
        super(props);

        this.state = {
            data: [],
            userDetails: {},
            cartState: '',
            loading: true,
            logout: false,
            productDisplayType: 2,
            isAdminVisibile: 'hidden',
            toChangePassword: false,
            menuVisibility: 'hidden',
            canTrack: 'hidden',
            isEditingForm : false,
            //Product Display type
            // 0 - Grid
            // 1 - List with images
            // 2 - List Table
            settingQuantity: false,
            products: [],
            brands: [],
            cartItems: [],
            itemQuantity: 0,
            selectedBrand: '',
            searchedText: '',
            loadingBrands: true,
            loadingCart: false,
            availableCartItems: false,
            loadingProducts: false,
            productCount: 0,
            toOrderFormList: false,

            shoppingCartWidth: '100%',
            productListWidth: '100%',

            closeCartButtonWidth: '50px',
            closeCartButtonPadding: '6px 12px',
            closeCartButtonVisibility: 'visible',

            openCartButtonWidth: '0',
            openCartButtonPadding: '0',
            openCartButtonVisibility: 'hidden',

            toCheckOut: false,
            toSaveCart: false,
            toManage: false,
            toInvoiceCredits: false,
            toOrderForm: false,
            toAdmin: false,

            toBudgets: false,
            toOrderSearch: false,
            toOrderApproval: false,
            toSavedCarts: false,
            toClearCartPrompt: false,
            toProducts: false,
            imagelocation: '',
            sessionExists: true,
            toSessionTimedOut: false,
        };

        this.CheckSessionAndInitialize();

    }

    RunAllInitializers() {
        this.GetUserDetails();
        this.isEditingForm();
        this.GetDefaultImageFolder();
        this.CheckIfAdmin();
        this.CheckIfCanTrack();
        this.RunInitializers();
    }

    CheckSessionAndInitialize() {
        this.setState({ complete_update: false });

        fetch('api/Login/CheckSession?buster=' + + new Date().getTime(), { credentials: "same-origin", 'Cache-Control' : 'no-cache, no-store', Pragma : 'no-cache' })
            .then(response => response.text())
            .then(data => {
                if (data == 'running') {
                    this.setState({ toSessionTimedOut: false });
                    this.RunAllInitializers();
                }
                else if (data == 'timedout'){
                    this.setState({ toSessionTimedOut: true });
                }
            });
    }

    CheckSession() {
        this.setState({ complete_update: false });

        fetch('api/Login/CheckSession?buster=' + + new Date().getTime(), { credentials: "same-origin", 'Cache-Control' : 'no-cache, no-store', Pragma : 'no-cache' })
            .then(response => response.text())
            .then(data => {
                if (data == 'running') {
                    this.setState({ toSessionTimedOut: false });
                }
                else if (data == 'timedout'){
                    this.setState({ toSessionTimedOut: true });
                }
            });
    }

    GetCartState() {

        fetch('/api/Form/GetCartCount?buster=' + new Date().getTime(), { credentials: "same-origin", 'Cache-Control' : 'no-cache, no-store', Pragma : 'no-cache' })
            .then(response => response.text())
            .then(data => {
                if (data == "valued") {
                    this.setState({ toClearCartPrompt: true });
                } else {
                    window.location.href = '\\';
                }
            });
    }

    GetUserDetails() {
        fetch('api/Login/GetUserDetails?buster=' + new Date().getTime(), { credentials: "same-origin", 'Cache-Control': 'no-cache, no-store', Pragma: 'no-cache' })
            .then(response => response.json())
            .then(data => { this.setState({ userDetails: data }) });

    }

    GetDefaultImageFolder() {
        fetch('api/Global/GetDefaultImageLocation', { credentials: "same-origin", 'Cache-Control' : 'no-cache, no-store', Pragma : 'no-cache' })
            .then(response => response.text())
            .then(data => {
                this.setState({ imagelocation: data });
            })
    }

    CheckIfAdmin() {
        fetch('/api/Login/isAdmin?buster=' + new Date().getTime(), { credentials: "same-origin", 'Cache-Control': 'no-cache, no-store', Pragma: 'no-cache' })
            .then(response => response.text())
            .then(data => { this.setState({ isAdminVisibile: (data == 'Y' ? 'visible' : 'hidden') }) });
    }

    CheckIfCanTrack() {
        fetch('/api/Login/canTrack?buster=' + new Date().getTime(), { credentials: "same-origin", 'Cache-Control': 'no-cache, no-store', Pragma: 'no-cache' })
            .then(response => response.text())
            .then(data => {
                this.setState({ canTrack: (data == 'Y' ? 'visible' : 'hidden') })
            });
    }

    RunInitializers() {

        this.GetCartItems();
        this.Getbrands();
        this.GetInitialProducts();
        this.setState({ loading: false });
        //this.InitializeProducts();
    }

    GoToBudget() {
        this.setState({ toBudgets: true });
    }

    GoToOrderSearch() {
        this.setState({ GoToOrderSearch: true });
    }

    openShoppingCart() {

        this.setState({
            shoppingCartWidth: '30%',
            productListWidth: '70%',

            closeCartButtonWidth: '50px',
            closeCartButtonPadding: '6px 12px',
            closeCartButtonVisibility: 'visible',

            openCartButtonWidth: '0',
            openCartButtonPadding: '0',
            openCartButtonVisibility: 'hidden'
        })
    }

    closeShoppingCart() {

        this.setState({ shoppingCartWidth: '0%' });
        this.setState({ productListWidth: "100%" });

        this.setState({ openCartButtonWidth: "50px" });
        this.setState({ openCartButtonPadding: "6px 12px" });
        this.setState({ openCartButtonVisibility: "visible" });

        this.setState({ closeCartButtonWidth: "0" });
        this.setState({ closeCartButtonPadding: "0" });
        this.setState({ closeCartButtonVisibility: "hidden" });

    }

    handleSelectedBrand(e) {
        let { name, value } = e.target;
        this.setState({ selectedBrand: e.target.value }
            , () => {

                if (this.state.selectedBrand == '') {
                    console.log('select brand is empty products');
                }
                else {
                    this.GetProducts();
                }
            })
    }

    

    SelectBrand(value) {
        this.setState({ selectedBrand: value },
            () => { this.GetProducts() });

    }

    handleSearchBrand(e) {
        let inputtext = e.target.value;
        this.setState({ searchedText: inputtext });
    }

    Getbrands() {
        fetch('/api/Form/GetBrands?buster=' + new Date().getTime(), { credentials: "same-origin", 'Cache-Control' : 'no-cache, no-store', Pragma : 'no-cache' })
            .then(response => response.json())
            .then(data => { this.setState({ brands: data }) })
            .then(() => {
                this.setState({ loadingBrands: false });
            })
    }

    GetInitialProducts() {

        this.setState({ loadingProducts: true });

        fetch('/api/Product/GetInitialProducts' + '?buster=' + new Date().getTime(), { credentials: "same-origin", 'Cache-Control' : 'no-cache, no-store', Pragma : 'no-cache' })
            .then(response => response.json())
            .then(data => { this.setState({ products: data, loadingProducts: true }); })
            .then(() => {
                this.setState({ loadingProducts: false });

            });

    }

    GetProducts() {

        this.setState({ loadingProducts: true });
        this.CheckSession();

        if (this.state.toSessionTimedOut == false) {
            fetch('/api/Form/GetProducts?brandcode=' + this.state.selectedBrand + '&buster=' + + new Date().getTime(), { credentials: "same-origin", 'Cache-Control' : 'no-cache, no-store', Pragma : 'no-cache' })
                .then(response => response.json())
                .then(data => { this.setState({ products: data, loadingProducts: true }); })
                .then(() => {
                    this.setState({ loadingProducts: false });
                });
        }

    }

    GetAutoForm() {

        this.setState({ loadingProducts: true });
        this.CheckSession();

        if (this.state.toSessionTimedOut == false) {
            fetch('/api/Form/GetAutoOrderForm' + '?buster=' + new Date().getTime(), { credentials: "same-origin", 'Cache-Control' : 'no-cache, no-store', Pragma : 'no-cache' })
                .then(response => response.json())
                .then(data => { this.setState({ products: data, loadingProducts: true }); })
                .then(() => {
                    this.setState({ loadingProducts: false });
                });
        }
    }

    SearchAll() {
        this.setState({ products: [], loadingProducts: true });

        fetch('/api/Form/SearchProducts?search=' + ' ' + '&buster=' + new Date().getTime(), { credentials: "same-origin", 'Cache-Control' : 'no-cache, no-store', Pragma : 'no-cache' })
            .then(response => response.json())
            .then(data => { this.setState({ products: data, loadingProducts: true }); })
            .then(() => {
                this.setState({ loadingProducts: false });

            });
    }

    InitializeProducts() {
        this.setState({ products: [], loadingProducts: true });

        fetch('/api/Form/InitializeProducts?search=' + '&buster=' + new Date().getTime(), { credentials: "same-origin", 'Cache-Control' : 'no-cache, no-store', Pragma : 'no-cache' })
            .then(response => response.json())
            .then(data => { this.setState({ products: data, loadingProducts: true }); })
            .then(() => {
                this.setState({ loadingProducts: false });

            });
    }

    SearchProducts() {
        this.setState({ products: [], loadingProducts: true });
        this.CheckSession();

        if (this.state.toSessionTimedOut == false) {
            fetch('/api/Form/SearchProducts?search=' + this.state.searchedText + '&buster=' + new Date().getTime(), { credentials: "same-origin", 'Cache-Control' : 'no-cache, no-store', Pragma : 'no-cache' })
                .then(response => response.json())
                .then(data => { this.setState({ products: data, loadingProducts: true }); })
                .then(() => {
                    this.setState({ loadingProducts: false });

                });
        }
    }

    AddCartItem(id) {

        this.setState({ loadingCart: true });
        this.CheckSession();

        if (this.state.toSessionTimedOut == false) {
            fetch('/api/Form/AddToCart?id=' + id + '&buster =' + new Date().getTime(), { credentials: "same-origin", 'Cache-Control' : 'no-cache, no-store', Pragma : 'no-cache' })
                .then(response => response.json())
                .then(data => { this.setState({ cartItems: data }) })
                .then(() => {
                    this.setState({ loadingCart: false });
                })
        }

    }

    SetNewQuantityProd(e) {

        this.setState({ settingQuantity: true });
        this.CheckSession();

        if (this.state.toSessionTimedOut == false) {
            let id = e.target.id;
            let quantity = e.target.value;

            fetch('/api/Form/SetNewQuantityProd?itemCode=' + id + '&quantity=' + quantity + '&buster=' + new Date().getTime(), { credentials: "same-origin", 'Cache-Control' : 'no-cache, no-store', Pragma : 'no-cache' })
                .then(() => {
                    this.setState({ settingQuantity: false });
                });
        }


    }

    SaveCart() {
        this.CheckSession();

        if (this.state.toSessionTimedOut == false) {
            fetch('/api/Form/ValidateCart?buster=' + new Date().getTime(), { credentials: "same-origin", 'Cache-Control': 'no-cache, no-store', Pragma: 'no-cache' })
                .then(response => response.text())
                .then(data => {
                    if (data == "true")
                    {
                        fetch('/api/Orderform/SaveOrderForm' + '?buster=' + new Date().getTime(), { credentials: "same-origin", 'Cache-Control': 'no-cache, no-store', Pragma: 'no-cache' })
                        .then(() => { this.setState({ toOrderFormList: true }); });
                    }
                    else
                        alert('There are items in the cart which are above and or below their allowed quantities please look at the description of the highlighted(red) cart items.');
                });
            
        }
    }

    SetNewQuantityCart(e) {

        this.setState({ settingQuantity: true });
        let id = e.target.id;
        let quantity = e.target.value;

        fetch('/api/Form/SetNewQuantityCart?itemCode=' + id + '&quantity=' + quantity)
            .then(() => {
                this.setState({ settingQuantity: false });
            })

    }


    SetNewQuantityCartItem(e) {

        this.setState({ settingQuantity: true });
        let id = e.target.id;
        let quantity = e.target.value;

        fetch('/api/Form/UpdateOrderItemQuantity?productId=' + id + '&quantity=' + quantity + '&buster=' + new Date().getTime(), { credentials: "same-origin", 'Cache-Control' : 'no-cache, no-store', Pragma : 'no-cache' })
            .then(() => {
                this.setState({ settingQuantity: false });
                this.GetCartItems();
            })

    }

    Checkout() {
        fetch('/api/Form/PlaceOrder' + '?buster =' + new Date().getTime(), { credentials: "same-origin", 'Cache-Control' : 'no-cache, no-store', Pragma : 'no-cache' })
            .then(() => { this.setState({ toCheckOut: true }); })
    }

    InvoiceCredits() {
        this.setState({ toInvoiceCredits: true });
    }

    Manage() {
        this.setState({ toManage: true });
    }

    toOrderForm() {
        this.setState({ toOrderForm: true });
    }

    RemoveCartItem(id) {

        this.setState({ loadingCart: true });
        this.CheckSession();

        if (this.state.toSessionTimedOut == false) {
            fetch('/api/Form/RemoveFromCart?id=' + id + '&buster=' + new Date().getTime(), { credentials: "same-origin", 'Cache-Control' : 'no-cache, no-store', Pragma : 'no-cache' })
                .then(response => response.json())
                .then(data => { this.setState({ cartItems: data }) })
                .then(() => {
                    this.setState({ loadingCart: false });
                });
        }
    }

    RemoveAllCartItems() {
        this.setState({ loadingCart: true });
        this.CheckSession();

        if (this.state.toSessionTimedOut == false) {
            fetch('/api/Form/ClearCart' + '?buster=' + new Date().getTime(), { credentials: "same-origin", 'Cache-Control' : 'no-cache, no-store', Pragma : 'no-cache' })
                .then(response => response.json())
                .then(data => { this.setState({ cartItems: data }) })
                .then(() => {
                    this.setState({ loadingCart: false });
                });
        }
    }

    LoadBrandToDropDown() {

        if (this.state.loadingBrands) {
            return (<option>loading...</option>);
        }
        else {
            return (this.state.brands.map(brand =>
                <div id={'div' + brand.value} key={'div' + brand.value} style={{ width: '100%' }}>
                    <button id={'btn' + brand.value} key={'btn' + brand.value} className="icon_add_to_cart" style={{ width: '85%', textAlign: 'left', fontWeight: '700', padding: '4px 10px', marginBottom: '5px' }} onClick={() => this.SelectBrand(brand.value)}>{brand.text}</button>
                </div>
            ));
        }
    }

    LoadProductsGrid() {

        let altImageLocation = this.state.imagelocation;

        if (this.state.loadingProducts) {
            return (<div className="inner-container">
                <div className="centered-content  twfont customer_background_foreground">
                    <div className="spinner-border" style={{ color: 'rgb(8, 15, 83)' }} role="status">
                        <span className="sr-only">Loading...</span>
                    </div>
                </div>
            </div>)
        }
        else {
            return (
                this.state.products.map(product =>
                    <div className="grid">
                        <div className="cardContainer #343A40 ">
                            <div id={product.itemCode} className="card customer_border_color" style={{ width: '100%', height: '100%' }}>
                                <div id="top" className="card-img-top customer_background_foreground_reverse" style={{ paddingTop: '5px', backgroundColor: 'whitesmoke', borderRadius: '0' }}>
                                    <div className="item_image underline-from-center">
                                        <div className="cardTop customer_background_foreground_reverse">
                                            <div style={{ 'padding-left': '10px', 'padding-top': '2px', 'width': '240px' }}>
                                                <label ID="imghotel" className="horizontal_overflow">{product.description}</label>
                                            </div>
                                            <a onClick={() => { this.AddCartItem(product.sysproProductCode) }}>
                                                <i className="icon_add_to_cart material-icons" >add</i>
                                            </a>
                                        </div>

                                        <img type="image" style={{ backgroundColor: 'white' }} onError={(e) => { e.target.onerror = null; e.target.src = altImageLocation }} id="imProd" src={product.imageUrl} className="image_border border_bottom customer_tertiary_background" onClick={() => { this.AddCartItem(product.sysproProductCode) }} />
                                    </div>
                                </div>
                                <div className="card-body customer_background_foreground_reverse" style={{ 'background-color': 'whitesmoke', width: '100%', display: 'inline-block', 'vertical-align': 'bottom', 'padding-bottom': '5px', 'padding-top': '5%', 'border-radius': '0' }}>
                                    <table className="cardTable" style={{ width: '100%', 'text-align': 'center', 'vertical-align': 'central' }}>
                                        <tr>
                                            <td style={{ 'font-weight': 'bold' }}>
                                                <label>R</label><label ID="lblPrice">{product.unitPrice}</label>
                                            </td>
                                            <td style={{ 'font-weight': 'bold' }}>
                                                <label style={{ 'margin-right': '3px' }}>QTY </label>
                                                <label id="lblPrice">{product.quantityOnHand}</label>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <label>Item Code</label>
                                            </td>
                                            <td>
                                                <label>{product.itemCode}</label>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <label>Unit Of Measure</label>
                                            </td>
                                            <td>
                                                <label>{product.uomdescription}</label>
                                            </td>
                                        </tr>
                                    </table >
                                </div >
                            </div >
                        </div>
                    </div>
                ));
        }

    }

    IncreaseSize(e) {
        if (e.target.height != 200)
            e.currentTarget.style.height = '200px';
        else
            e.currentTarget.style.height = '50px';
    }

    LoadProductsTable() {
        let altImageLocation = this.state.imagelocation;

        if (this.state.loadingProducts) {
            return (
                <div>
                    <div>
                        <div className="spinner-border" style={{ color: 'black' }} role="status">
                            <span className="sr-only">Loading...</span>
                        </div>
                    </div>
                </div>
            )
        }
        else {
            let backcolor = 'black';

            return (this.state.products.map(product =>
                <tr id={'tr' + product.itemCode} key={'tr' + product.itemCode} style={{ lineHeight: '50px', borderBottom: 'solid 1px' }}>
                    <td style={{ width: '60px' }}><img id={'img' + product.itemCode} type="image" className="table_image_border" onClick={this.IncreaseSize.bind(this)} onError={(e) => { e.target.onerror = null; e.target.src = altImageLocation }} id="imProd" src={product.imageUrl} /></td>
                    <td style={{ textAlign: 'left' }}>{product.itemCode}</td>
                    <td style={{ textAlign: 'left' }}>{product.description}</td>
                    <td style={{ textAlign: 'left' }}>{product.uomdescription}</td>
                    <td style={{ textAlign: 'left' }}>{product.quantityOnHand > 0 ? 'Available' : 'Unavailable'}</td>
                    <td style={{ textAlign: 'left', display: 'none' }}>{product.sysproProductCode}</td>
                    <td style={{ textAlign: 'left' }}>R {Number(product.unitPrice).toFixed(2)}</td>
                    <td>
                        <input id={product.itemCode} style={{ width: '60px' }} className="form-control" type="number" onChange={this.SetNewQuantityProd.bind(this)} defaultValue={product.quantityChosen} />
                    </td>
                    <td><button className="btn customer_background_foreground" onClick={() => this.AddCartItem(product.sysproProductCode)} style={{ cursor: 'pointer', height: '38px' }}><i className="icon_add_to_cart material-icons tertiary_btn">add</i></button></td>
                </tr>
            ));
        }
    }

    LoadProducts() {
        if (this.state.productDisplayType == 0) {
            let productsGrid = this.LoadProductsGrid();

            return (
                <div id="GridContainer" className="gridContainer customer_base_background">
                    {productsGrid}
                </div>
            );
        }
        else if (this.state.productDisplayType == 1) {

        }
        else if (this.state.productDisplayType == 2) {
            if (this.state.loadingProducts) {
                return (
                    <div>
                        <div>
                            <div className="spinner-border" style={{ color: 'red' }} role="status">
                                <span className="sr-only">Loading...</span>
                            </div>
                        </div>
                    </div>
                )
            }
            else {
                let tableGrid = this.LoadProductsTable();

                return (
                    <table className="customer_background_foreground_reverse" style={{ width: '100%' }}>
                        <tbody>
                            <tr className="customer_background_foreground">
                                <th></th>
                                <th style={{ textAlign: 'left' }}>Item Code</th>
                                <th style={{ textAlign: 'left' }}>Description</th>
                                <th style={{ textAlign: 'left' }}>UOM</th>
                                <th style={{ textAlign: 'left' }}>Status</th>
                                <th style={{ textAlign: 'left', display: 'none' }}></th>
                                <th style={{ textAlign: 'left' }}>Unit Price</th>
                                <th style={{ textAlign: 'left' }}>Quantity</th>
                                <th></th>
                            </tr>
                            {tableGrid}
                        </tbody>
                    </table>
                );
            }
        }
    }


    GoBackToProducts() {
        this.setState({ toProducts: true });
    }

    isEditingForm() {
        fetch('/api/Orderform/isEditingOrderForm?buster=' + new Date().getTime(), { credentials: "same-origin", 'Cache-Control' : 'no-cache, no-store', Pragma : 'no-cache' })
            .then(response => response.text())
            .then(data => {
                this.setState({ isEditingForm: data == 'true' });
            });
    }

    GetCartItems() {

        fetch('/api/Form/GetCartItems' + '?buster=' + new Date().getTime(), { credentials: "same-origin", 'Cache-Control' : 'no-cache, no-store', Pragma : 'no-cache' })
                                .then(response => response.json())
                                .then(data => { this.setState({ cartItems: data }) })
                                .then(() => {
                                    this.setState({ loadingCart: false });
                                });
    }

    LoadCartItems() {
        if (this.state.loadingCart) {
            return (<div>
                <div>
                    <div className="spinner-border" style={{ color: 'rgb(8, 15, 83)' }} role="status">
                        <span className="sr-only">Loading...</span>
                    </div>
                </div>
            </div>)

        }
        else {
            return (
                this.state.cartItems.map(cartItem =>
                    <div id={'cid' + cartItem.id} key={'ckey' + cartItem.id}>
                        <div className="info-box" style={{ fontFamily: 'TW Cen MT', margin: '2% 3% 0 3%', width: '90%', height: '140px', border: cartItem.isvalid ? 'none' : 'solid red'  }}>

                            <div className="content" style={{ float: 'left', width: '80%', margin: '0' }}>
                                <div >
                                    <div>
                                        <div className="text" style={{ fontWeight: 'bold' }}>{cartItem.id}</div>
                                        <div className="text" style={{ width: '171px', height: '19.2px', overflow: 'hidden', textOverflow: 'ellipsis', fontWeight: 'bold' }}>{cartItem.description}</div>
                                        <div className="text" style={{ fontWeight: 'bold' }}>
                                            R {Number(cartItem.price).toFixed(2)} : {cartItem.uom}  </div>
                                        <div className="number count-to" style={{ marginTop: '1px' }} data-from="0" data-to="125" data-speed="1000" data-fresh-interval="20">
                                            Quantity : <input id={cartItem.id} style={{ width: '70px', height: '25px' }} type="number" onChange={this.SetNewQuantityCartItem.bind(this)} defaultValue={cartItem.quantity} />
                                        </div>

                                        <div className="number count-to" style={{ marginTop: '1px', overflow: 'overlay', maxHeight: '24px' }} data-from="0" data-to="125" data-speed="1000" data-fresh-interval="20">Ext Price: R {Number(cartItem.price * cartItem.quantity).toFixed(2)}</div>
                                    </div>
                                </div>
                            </div>

                            <div className="icon" style={{ backgroundColor: 'white', float: 'right' }}>
                                <a style={{ padding: '0' }} onClick={() => { this.RemoveCartItem(cartItem.id) }} >
                                    <i className="material-icons" style={{ color: 'red', fontSize: '30px' }}>delete</i>
                                </a>
                            </div>
                        </div>
                    </div>
                )
            )
        }
    }

    LogUserOut(state) {
        console.log('cart state : ' + state);
    }

    GoToAdmin() {
        this.setState({ toAdmin: true });
    }

    GoBackToProducts() {
        this.setState({ toProducts: true });
    }

    GoToBudget() {
        this.setState({ toBudgets: true });
    }

    GoToOrderForm() {
        this.setState({ toOrderForms: true });
    }

    GoToOrderSearch() {
        this.setState({ GoToOrderSearch: true });
    }

    GoToOrderApproval() {
        this.setState({ toOrderApproval: true });
    }

    GoToSavedCarts() {
        this.setState({ toSavedCarts: true });
    }

    OrderFormList() {
        this.setState({ toOrderFormList: true });
    }
    

    ToChangePassword() {
        fetch('/api/Login/CanUpdatePassword' + '?buster=' + new Date().getTime(), { credentials: "same-origin", 'Cache-Control' : 'no-cache, no-store', Pragma : 'no-cache' })
            .then(response => response.text())
            .then(response => {

                if (response == 'true')
                    this.setState({ toChangePassword: true });
                else
                    alert('You currently do not have the required permissions to change your password.');

            });
    }

    MenuClick() {

        if (this.state.menuVisibility == 'hidden') {
            this.setState({ menuVisibility: 'visible' });
        }
        else if (this.state.menuVisibility == 'visible') {
            this.setState({ menuVisibility: 'hidden' });
        }
    }


    render() {

        if (this.state.toSessionTimedOut) {
            return <Route path='/' component={SessionTimedOut} />
        }

        if (this.state.toClearCartPrompt) {
            return <Route path='/' component={ClearCartPrompt} />
        }
        if (this.state.toAdmin) {
            return (<Route path='/' component={AdminManage} />);
        }

        if (this.state.GoToOrderSearch) {
            return <Route path='/' component={OrderSearch} />
        }

        if (this.state.toBudgets) {
            return <Route path='/' component={Budget} />
        }

        if (this.state.toSavedCarts) {
            return <Route path='/' component={SavedCarts} />
        }


        if (this.state.toChangePassword) {
            return <Route path='/' component={ChangePassword} />

        }

        if (this.state.toOrderForm) {
            return <Route path='/' component={OrderFormList} />

        }

        if (this.state.toSaveCart) {
            return <Route path='/' component={SaveCart} />
        }

        if (this.state.toManage) {
            return <Route path='/' component={Manage} />
        }


        if (this.state.toOrderFormList) {
            return <Route path='/' component={OrderFormList} />
        }


        if (this.state.toCheckOut) {
            return <Route path='/' component={CheckOut} />
        }

        if (this.state.toInvoiceCredits) {
            return <Route path='/' component={InvoiceOrderSearch} />
        }
        if (this.state.toOrderApproval) {
            return <Route path='/' component={OrderApproval} />
        }

        if (this.state.toProducts) {
            return <Route path='/' component={Product} />
        }
        else {
            if (this.state.logout) {
            }
            else {

                let brandsDropDown = this.LoadBrandToDropDown();
                let products = this.LoadProducts();
                let cartItems = this.LoadCartItems();

                return (
                    <div>
                        <div className="outer-container customer_background" >

                            <div className="header" style={{ position: 'fixed', zIndex : '500'}}>
                                <div className="grid_container_header" style={{ display: 'inline-grid', msHyphens: 'auto', gridTemplateColumns: '30% 40% 30%', display: 'grid -ms-grid', msGridColumns: '30% 40% 30%', columnCount: '3' }}>
                                    <div className="grid_header">
                                        <div className="icon_home" style={{ width: '100%', height: '50%', marginTop: '30px', marginLeft: '10%', float: 'left', backgroundRepeat: 'no-repeat' }}></div>
                                    </div>
                                    <div className="grid_header" style={{ textAlign: 'left', overflow: 'hidden' }}>
                                        <div className="header_container" style={{ width: '100%' }}>
                                            <div>
                                                <div style={{ display: 'inline', display: '-ms-grid' }}>
                                                    <a className="header_text" onClick={() => this.GoBackToProducts()}  >Place Order</a>|
                                                    <a className="header_text" onClick={() => this.GoToOrderSearch()} >Documents</a>
                                                    <span style={{ visibility: this.state.canTrack }}>|</span>
                                                    <a className="header_text" onClick={() => this.GoToOrderApproval()} style={{ visibility: this.state.canTrack }} >Order Approval</a>
                                                    <span style={{ visibility: this.state.isAdminVisibile }}>|</span>
                                                    <a className="header_text" onClick={() => this.GoToBudget()} style={{ visibility: 'hidden' }}>Budgets</a>
                                                    <span style={{ visibility: this.state.isAdminVisibile }}>|</span>
                                                    <a className="header_text" onClick={() => this.GoToAdmin()} style={{ visibility: this.state.isAdminVisibile }} >Admin</a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="grid_header">
                                        <div className="header_container greeting" style={{ width: '100%' }}>
                                            <div className="header_text grid_item_1" style={{ lineHeight: '40px', textAlign: 'right' }}>
                                                <div style={{ height: '28px' }} className="overflow_header"> {this.state.userDetails.greeting + ', ' + this.state.userDetails.fullname}</div>
                                                <div style={{ height: '30px' }} className="overflow_header">{this.state.userDetails.accountName}</div>
                                                <div style={{ height: '28px' }} className="overflow_header">Group : {this.state.userDetails.accountCode}</div>
                                            </div>
                                            <div className="grid_item_2_reverse  h100">
                                                <div style={{ width: '100%', 'height': '100%' }}>
                                                    <button id="btnMenu" onClick={() => this.MenuClick()} className="btn primary_btn header_btn twfont" style={{ lineHeight: '0.8', marginTop: '10px'  }}  ><i className="material-icons" style={{ width: '100%' }} >menu</i><label>Options</label></button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="header_menu_container" style={{ visibility: this.state.menuVisibility }}>
                                <div>
                                    <button onClick={() => { this.MenuClick() }} style={{ width: '100%', height: '100%', backgroundColor: 'transparent', border: 'none' }}></button>
                                </div>
                                <div className="header_menu customer_background_foreground">
                                    <hr />
                                    <div>
                                        <button className="btn  header_menu_item" onClick={() => { this.ToChangePassword() }}>Reset Password <i className="material-icons" style={{ position: 'relative', top: '6px', paddingLeft: '10px' }}>vpn_key</i></button>
                                    </div>
                                    <hr />
                                    <div>
                                        <button className="btn  header_menu_item" onClick={() => { this.GetCartState() }}>Logout <i className="material-icons" style={{ position: 'relative', top: '6px', paddingLeft: '10px' }}>exit_to_app</i></button>
                                    </div>
                                    <hr />
                                </div>
                            </div>

                            <div className=" sidenav customer_background_foreground_reverse" style={{ width: '100%', minHeight: '1000px', marginTop: '100px' }}>
                                <div style={{ width: '100%', textAlign: 'center' }}>
                                    <div style={{ height: '100%', width: '100%' }}>
                                        <div className="product_container" >
                                            <div className="BrandList customer_secondary_background grid_item_1">
                                                <hr />
                                                <div id="Filters" style={{ borderColor: '#2C3160', height: '100%', fontFamily: 'TW Cen MT' }}>
                                                    <div style={{ height: '100%' }}>
                                                        <label style={{ fontFamily: 'TW Cen MT', fontSize: 'x-large', padding: '10px' }}>Filter</label>
                                                        <div style={{ height: '100%', marginLeft: '10px', paddingBottom: '50px' }} className="customer_base_background">
                                                            <br />
                                                            <div style={{ height: '100%', paddingLeft: '10px' }}>
                                                                {brandsDropDown}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div id="productList" className="main_content_container  grid_item_2" style={{ backgroundColor: '#138496', color: 'black' }} >
                                                <hr />

                                                <div className="order_form_header_grid">
                                                    <div className="input-group mb-3 grid_item_1" >
                                                        <input type="text" id="txtMainSearch" style={{ fontFamily: 'TW Cen MT' }} className="form-control" placeholder="Search..." onChange={this.handleSearchBrand.bind(this)} />
                                                        <div className="input-group-prepend">
                                                            <button id="btnMainSearch" onClick={() => this.SearchProducts()} className="btn primary_btn" style={{ height: '38px' }} ><i className="material-icons">search</i></button>
                                                        </div>
                                                    </div>
                                                    <div className="grid_item_2" style={{ textAlign: 'center', fontFamily: 'TW Cen MT', fontSize: 'x-large', color: 'white' }}>
                                                        <label>Create Order Form1</label>
                                                    </div>
                                                </div>
                                                <hr />
                                                <div style={{ backgroundColor: 'white', height: '100%', fontFamily: 'Tw Cen MT' }}>
                                                    {products}
                                                </div >
                                            </div>
                                            <div id="shoppingCart" className="sidenav customer_background_foreground_reverse grid_item_3" style={{ width: '100%', border: 'none', marginTop: '5px' }}>

                                                <div id="divRight" className="cart_container customer_secondary_background " style={{ height: '100%', padding: '10px', textAlign: 'left' }}>
                                                    <hr />
                                                    <div>
                                                        <table style={{ width: '100%' }}>
                                                            <tbody>
                                                                <tr><td><button id="btnSave" onClick={() => this.SaveCart()} className="btn tertiary_btn shopping_cart_btn" style={{ visibility: !this.state.isEditingForm ? 'visible' : 'hidden' }} >Save Order Form<i className="material-icons" style={{ position: 'relative', top: '6px', paddingLeft: '10px'}}>shopping_cart</i></button></td></tr>
                                                                <tr><td><button id="btnUpdate" onClick={() => this.SaveCart()} className="btn tertiary_btn shopping_cart_btn" style={{visibility: this.state.isEditingForm ? 'visible' : 'hidden'}} >Update<i className="material-icons" style={{ position: 'relative', top: '6px', paddingLeft: '10px' }}>save</i></button></td></tr>
                                                                <tr><td><button id="btnCancel" onClick={() => this.RemoveAllCartItems()} className="btn secondary_btn shopping_cart_btn">Clear<i className="material-icons" style={{ position: 'relative', top: '6px', paddingLeft: '10px' }}>block</i></button></td></tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                    <hr />
                                                    <div className="customer_base_background" style={{ height: '100%', paddingTop: '2px' }}>
                                                        <div>
                                                            {cartItems}
                                                        </div>
                                                    </div >

                                                    <div style={{ position: 'fixed', bottom: '0', padding: '10px', width: '17%' }}>
                                                        <button id="btnCheckout" onClick={() => this.SaveCart()} className="btn tertiary_btn finalize_btn" style={{ fontFamily: 'Tw Cen MT', margin: '3% 0 3%', border: 'solid 1px' }} >Save Order Form<i className="material-icons" style={{ position: 'absolute', paddingLeft: '10px' }}>shopping_cart</i></button>
                                                    </div>
                                                </div >


                                            </div >
                                        </div>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>
                );

            }
        }

    }
}

////<button id="filter_btn" className="customer_btn btn btn-outline-dark default_btn" style={{ width: '20%', 'font-family': 'Tw Cen MT' }} data-toggle="collapse" data-target="#Filters">Filters</button>

////    <button ID="GridButton" className="btn customer_background_foreground customer_btn" style={{ padding: '6px', height: '38px' }}>
////        <i className="material-icons">grid_on</i>
////    </button>

////    <button ID="ListButton" className="btn customer_background_foreground customer_btn" style={{ padding: '6px', height: '38px' }}>
////        <i className="material-icons">view_list</i>
////    </button >


////    <hr />


